import moment from 'moment/moment'

/**
 * @mixin
 */
export default {
    data: () => ({
        timeoutExpired: false,
        timeoutInterval: false
    }),
    props: {
        /**
         * Date format being passed in to the `timeoutDate` prop.
         * Note: formatting is achieved through the `moment.js` package.
         * View https://momentjs.com/docs/#/parsing/string-format/ for info on the formatting string options.
         */
        dateFormat: {
            type: String,
            default: 'YYYY-MM-DD HH:mm:ss'
        },
        /**
         * Timeout start date.
         */
        timeoutDate: {
            type: [String, Object, Date],
            default: ''
        },
        /**
         * Number of seconds from `timeoutDate` at which the button should be hidden.
         */
        timeout: {
            type: Number,
            default: 0
        }
    },
    computed: {
        timeoutProps () {
            return {
                dateFormat: this.dateFormat,
                timeoutDate: this.timeoutDate,
                timeout: this.timeout
            }
        }
    },
    methods: {
        checkTimeout () {
            const vm = this

            const currentDateFormatted = moment().format(vm.dateFormat)
            const expiryDateFormatted = moment(vm.timeoutDate, vm.dateFormat).add(vm.timeout, 'seconds')

            if (moment(currentDateFormatted).isAfter(expiryDateFormatted)) {
                vm.timeoutExpired = true
            }

            return vm.timeoutExpired
        },
        handleTimeout () {
            const vm = this

            if (vm.timeoutDate && !vm.timeoutInterval) {
                const check = vm.checkTimeout()

                if (!check) {
                    vm.timeoutInterval = setInterval(() => {
                        if (vm.checkTimeout()) {
                            clearInterval(vm.timeoutInterval)
                            vm.timeoutInterval = false
                        }
                    }, 1000)
                }
            }

            if (!vm.timeoutDate && vm.timeout > 0) {
                setTimeout(() => {
                    vm.timeoutExpired = true
                }, vm.timeout * 1000)
            }
        }
    },
    mounted () {
        this.handleTimeout()
    }
}
